<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.6 1.6H2.4A2.4 2.4 0 0 0 0 4v8a2.4 2.4 0 0 0 2.4 2.4h11.2A2.4 2.4 0 0 0 16 12V4a2.4 2.4 0 0 0-2.4-2.4zm-.328 1.6L8.568 7.904a.8.8 0 0 1-1.136 0L2.728 3.2h10.544zM14.4 12a.8.8 0 0 1-.8.8H2.4a.8.8 0 0 1-.8-.8V4.328l4.704 4.704a2.4 2.4 0 0 0 3.392 0L14.4 4.328V12z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
